import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'
import styled from 'styled-components'
import theme from 'styles/theme'

const Wrapper = styled.iframe`
  display: block;
  border: 0;
  position: relative;
  width: 100vw;
  min-height: 550px;
  height: calc(90vh - 35px - 30px - 54px - 90px);
  margin: 18px auto;

  ${theme.mediaQueries.large} {
    margin: 18px auto 100px;
    width: calc(100vw * 0.75);
    min-hieght: unset;
    height: calc((100vw * 0.75) * 0.5625);
  }
`

const Mappedin = ({ village, locale, leaseNumber }) => {
  const iframeUrl = `/map/${village}.html`
  const [url, setUrl] = useState(`${iframeUrl}`)

  useEffect(() => {
    let hash = ''

    if (window.location.hash) {
      // eslint-disable-next-line prefer-destructuring
      hash = window.location.hash
    } else if (leaseNumber) {
      hash = `#/profile?location=${leaseNumber}`
    }

    setUrl(`${iframeUrl}${hash}`)
  }, [])

  return (
    <LazyLoad once>
      <Wrapper src={url} data-lang={locale} />
    </LazyLoad>
  )
}

Mappedin.propTypes = {
  village: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  leaseNumber: PropTypes.string,
}

Mappedin.defaultProps = {
  leaseNumber: '',
}

export default Mappedin

// example URL with Hash
// http://localhost:8000/bicester-village/en/map#/location/5d4996abface6200122d7e8d
